import React, { Fragment } from 'react';
import { bool, any, func, string } from 'prop-types';

import { memoCallback } from '../../utils';
import { Sidebar } from '../../components/sidebar';
import ModalWindow from '../../modals/modal-window';
import { Navigation } from '../../containers/navigation';
import { Container, ContentRight, ContentChildren, MobileOverlay } from './styles';


const shouldComponentUpdate =
  (prevProps, nextProps) =>
    memoCallback(prevProps, nextProps, []);

export const MainLayoutComponent = React.memo(({
  route,
  children,
  isOpenMobile,
  isMenuCollapsed,
  setIsOpenMobile,
  isUserSuperAdmin,
  isUserSalesAgent,
  handleChangeIsMenuCollapsed,
}) => (
  <Fragment>
    <Container
      collapsed={isMenuCollapsed}
    >
      <Sidebar
        {...{
          route,
          isOpenMobile,
          setIsOpenMobile,
          isUserSalesAgent,
          isUserSuperAdmin,
          setIsMenuCollapsed: handleChangeIsMenuCollapsed,
          isMenuCollapsed: isOpenMobile ? false : isMenuCollapsed,
        }}
      />

      {
        isOpenMobile && <MobileOverlay
          onClick={() => {
            if (isOpenMobile) {
              setIsOpenMobile(!isOpenMobile);
            }
          }}
        />
      }

      <ContentRight>
        <Navigation setIsOpenMobile={setIsOpenMobile} />
        <ContentChildren>
          {children}
        </ContentChildren>
      </ContentRight>
    </Container>

    <ModalWindow />
  </Fragment>
), shouldComponentUpdate);

MainLayoutComponent.propTypes = {
  route: string,
  children: any,
  isOpenMobile: bool.isRequired,
  isMenuCollapsed: bool.isRequired,
  setIsOpenMobile: func.isRequired,
  isUserSuperAdmin: bool.isRequired,
  isUserSalesAgent: bool.isRequired,
  handleChangeIsMenuCollapsed: func.isRequired,
};

MainLayoutComponent.defaultProps = {
  route: '',
  children: null,
};



// WEBPACK FOOTER //
// ./src/layouts/main/component.js